import { render, staticRenderFns } from "./sub-request-type-card.vue?vue&type=template&id=49561374&scoped=true&"
import script from "./sub-request-type-card.vue?vue&type=script&lang=js&"
export * from "./sub-request-type-card.vue?vue&type=script&lang=js&"
import style0 from "./sub-request-type-card.vue?vue&type=style&index=0&id=49561374&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "49561374",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCol } from 'vuetify/lib/components/VGrid';
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VSheet } from 'vuetify/lib/components/VSheet';
import { VSkeletonLoader } from 'vuetify/lib/components/VSkeletonLoader';
installComponents(component, {VCol,VIcon,VSheet,VSkeletonLoader})
